export default __webpack_public_path__ + "locales/it/InviteDialog.json?hash=76864d6393d6128420e5171ee9c527cf";